/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Date = styled.p`
  color: ${Palette.PrimaryGray._500};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Container = styled.div`
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  height: 40px;
  display: flex;
  align-items: center;
  padding: 8px;
  white-space: nowrap;
  gap: 8px;
  cursor: pointer;
  :hover {
    border: 1px solid ${Palette.PrimaryGray._300};
    ${Date} {
      color: ${Palette.PrimaryGray._900};
    }
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      border: 1px solid var(--primary-300, #91c7fd);
      box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
      ${Date} {
        color: ${Palette.PrimaryGray._900};
      }
    `}
`;

export const LeftIcon = styled.div`
  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RightIcon = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  svg {
    transition: transform 0.2s linear;
    ${({ isOpen }) =>
      isOpen
        ? css`
            fill: ${Palette.Primary._500};
            transform: rotate(180deg);
          `
        : css`
            fill: ${Palette.PrimaryGray._400};
          `}
  }
`;

export const TypeName = styled.p`
  color: ${Palette.PrimaryGray._700};
  min-width: 90px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
